module.exports = __webpack_public_path__ + "media/images/login/VenuTRAX-WH-2-4b7c16beb18e1a892b4e956bc103a34d.png";